/* eslint-disable */
enum EOperator {
    EQUAL,
    LESS_THAN,
    MORE_THAN,
    LESS_EQ,
    MORE_EQ,
}
export default EOperator;
